import { Pipe, PipeTransform } from '@angular/core';
import { CommonNAFormatPipeService } from '@CaseOne/Common/pipes/common-na-format/common-na-format.service';

@Pipe({
	name: 'commonNAFormatter',
})
export class CommonNAFormatPipe implements PipeTransform {
	constructor (
		private commonNAFormatPipeService: CommonNAFormatPipeService,
	) {}

	transform(data, toBlank: boolean = false) {
		return this.commonNAFormatPipeService.transform(data, toBlank);
	}
}
